import React, { ComponentProps } from "react";
import Container from "react-bootstrap/Container";

export default function AuthLayout({ children }: ComponentProps<"div">) {
  return (
    <div className="auth-page__container d-flex justify-content-cener align-items-center">
      <Container>
        <div className="form-signup__container d-flex align-items-center justify-content-center text-left">
          {children}
        </div>
      </Container>
    </div>
  );
}